/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable import/no-named-as-default */
/* eslint-disable import/no-extraneous-dependencies */
import Modal from 'react-bootstrap/Modal';
import {useEffect, useState} from 'react';
import {toast} from 'react-toastify';
import Spreadsheet from 'react-spreadsheet';
import {Button} from 'react-bootstrap';

type TProps = {
	open: boolean;
	onClose?: () => void;
	data: string;
};

const ModalCSVView = (props: TProps) => {
	const [copied, setCopied] = useState(false);
	const [DATA, setDATA] = useState([]);

	useEffect(() => {
		if (props.data) {
			const tmp = csvToArray(props.data);
			setDATA(tmp as never);
		}
	}, [props.data]);

	useEffect(() => {
		if (copied) {
			toast.info('CSV successfully copied to clipboard');
			setCopied(false);
		}
	}, [copied]);

	return (
		<Modal
			centered
			size="xl"
			show={props.open}
			onHide={props.onClose}
			className="custom-modal-style">
			<Modal.Header closeButton>
				<Modal.Title id="contained-modal-title-vcenter">
					<h4 className="modal-title" id="ModalCSVViewLabel">
						<i className="bi bi-filetype-xml text-dark mr-2" /> CSV File Viewer
					</h4>
				</Modal.Title>
			</Modal.Header>
			<Modal.Body className="show-grid">
				<div className="modal-body overflow-scroll">
					<div className="row">
						<Spreadsheet data={DATA} />
					</div>
				</div>
			</Modal.Body>
			<Modal.Footer className="d-flex justify-content-end">
				<Button variant="secondary" onClick={props.onClose}>
					Close
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const csvToArray = (csv: string): any[][] => {
	const rows = csv.split('\n').map(row => row.split(','));
	return rows.map(row =>
		row.map(cell => ({value: cell.trim(), readOnly: true})),
	);
};

export default ModalCSVView;
